import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["form", "disabled"]
const _hoisted_2 = {
  key: 1,
  class: "bg-primary flex items-center text-white font-semibold px-5 mr-6 rounded"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([[_ctx.classColor], "cursor-pointer rounded-md flex justify-center items-center focus:outline-none"]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPressed && _ctx.onPressed(...args)))
      }, [
        _createElementVNode("button", {
          form: _ctx.form,
          class: "w-full h-full focus:outline-none border-none font-semibold tracking-wide",
          disabled: _ctx.disabled
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 8, _hoisted_1)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("svg", {
          class: "animate-spin h-5 w-5 mr-3",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          })
        ], -1)),
        _renderSlot(_ctx.$slots, "descricao-loading")
      ]))
}